import ExpandableContactButton from '../../Blocks/ExpandableContactButtonBlock/expandable-contact-button.js';
import TinyMceVideoPlayer from '../../Blocks/TinyMceVideoBlock/tinymce-video.js';

import Tooltip from "../../../frontend/js/tooltip.js";

class MembershipApplication {
    constructor() {
        this.addEventListener();
        this.addProgressEventListeners();
        this.addProgressEventListeners = this.addProgressEventListeners.bind(this);
        this.stepIndicators = [...document.querySelectorAll('.membership-application__step-item')];
        this.mobileIndicators = [...document.querySelectorAll('.membership-application__mobile-indicator')]
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.updateContactButtonPosition = this.updateContactButtonPosition.bind(this);
        this.ping();
        this.observe = this.observe.bind(this);
        const config = { attributes: false, childList: true, subtree: true };
        this.observer = new MutationObserver(this.observe);
        const formContainer = document.querySelector('.membership-application__form-container');
        const pageWrapContainer = document.querySelector('.membership-application__wrapper');
        this.expandableContactButton = new ExpandableContactButton();
        const progressContainer = document.querySelector('.membership-application__progress-container');
        this.observer.observe(formContainer, config)
        this.observer.observe(progressContainer, config)
        this.observer.observe(pageWrapContainer, config)
        this.expandableContactButton.init();
        this.updateContactButtonPosition();
        this.handleResize = this.handleResize.bind(this);
        
        window.addEventListener('resize', this.handleResize);
    }
    
    observe(mutationList, observer) {
        for (const mutation of mutationList) {
            if (mutation.type === 'childList') {
                const currentStep = this.getCurrentStepIndex();
                const expandableContactButton = document.querySelector('.expandable-contact-button');
                
                if (mutation.removedNodes.length) {
                    if (mutation.target.matches('.membership-application__wrapper')) {
                        this.addInputEventListeners();
                        this.expandableContactButton.init();
                    }
                    else if (mutation.target.matches('.membership-application__progress-container')) {
                        this.addProgressEventListeners();
                        const currentStep = this.getCurrentStepIndex();
                        if (currentStep === 0) {
                            window.lazyLoader.update();
                            new TinyMceVideoPlayer();
                        }
                    }
                    else if (mutation.target.matches('.membership-application__form-container')) {
                        this.addInputEventListeners();
                        this.initializeExpandableInfoElementsClickEvents();
                    }
                }


                if (!expandableContactButton) {
                    return;
                }
                
                if (currentStep === 0) {
                    expandableContactButton.classList.add('hidden')
                }
                else {
                    expandableContactButton.classList.remove('hidden')
                }
                    
            }
        }
    }
    
    handleResize() {
        //match when screen size is above 992px
        if (window.matchMedia("(min-width: 992px)").matches) {
            this.updateContactButtonPosition();
        }
    }
    
    updateContactButtonPosition() {
        const expandableContactButton = document.querySelector('.expandable-contact-button');
        if (expandableContactButton) {
            const pageWrap = document.querySelector('.page-wrap');
            const pageWrapRect = pageWrap.getBoundingClientRect();
            const computedStyle = window.getComputedStyle(pageWrap);
            const paddingLeft = parseFloat(computedStyle.paddingLeft);
            const paddingRight = parseFloat(computedStyle.paddingRight);
            const pageWrapWidth = pageWrapRect.width - paddingLeft - paddingRight;
            const rightPosition = (document.documentElement.clientWidth - pageWrapWidth) / 2;
            expandableContactButton.style.right = `${rightPosition}px`;
        }
    }
    
    getCurrentStepIndex() {
        const currentIndicator = document.querySelector('.membership-application__mobile-indicator--current');
        if (currentIndicator) {
            const indicators = [...document.querySelectorAll('.membership-application__mobile-indicator')];
            return indicators.indexOf(currentIndicator)
        }
    }

    async ping() {
        const stripTrailingSlash = (str) => {
            return str.endsWith('/') ?
                str.slice(0, -1) :
                str;
        };
        const url = stripTrailingSlash(window.location.pathname) + '/ping';
        const antiForgeryToken = document.querySelector('input[name=__RequestVerificationToken]').value;
        await fetch(url, {
            method: 'get',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                '__RequestVerificationToken': antiForgeryToken
            },
        })
        setTimeout(this.ping, 300000) // 5 min
    }

    addInputEventListeners() {
        const that = this;
        const invoiceKindToggler = document.querySelectorAll('[name="Form.InvoiceKind"]');
        const pdfBtn = document.getElementById('membership-application__step-four-button--pdf');
        const paperBtn = document.getElementById('membership-application__step-four-button--paper');
        if (pdfBtn || paperBtn) {
            pdfBtn.addEventListener('click', (e) => this.toggleInvoiceKind(e, pdfBtn, paperBtn, invoiceKindToggler[0]))
            paperBtn.addEventListener('click', (e) => this.toggleInvoiceKind(e, paperBtn, pdfBtn, invoiceKindToggler[1]))
        }

        const bankIdBtnOverlay = document.getElementById('bank-id-btn-overlay');
        const bankIdBtnErrorMsg = document.querySelector('.membership-application__button--bank-id-error');
        const acceptTermsCheckbox = document.querySelector('.membership-application__terms');
        if (acceptTermsCheckbox) {
            acceptTermsCheckbox.addEventListener('change', e => {
                const isChecked = e.target.checked;
                const submitButtons = document.querySelectorAll('.membership-application__button');
                submitButtons.forEach(x => x.disabled = !isChecked);
                isChecked ? bankIdBtnOverlay.style.display = 'none' : bankIdBtnOverlay.style.display = 'block';
                isChecked ? bankIdBtnErrorMsg.style.display = 'none' : null;
            })
        }

        if (bankIdBtnOverlay) {
            bankIdBtnOverlay.addEventListener('click', () => {
                bankIdBtnErrorMsg.style.display = 'block'
            })
        }

        const tinyMceButton = document.querySelector('.tinymce-video__play');
        if (tinyMceButton) {
            tinyMceButton.addEventListener("click", async e => {
                e.stopPropagation();
                e.preventDefault();
            });
        }

        const formContainer = document.querySelector('.membership-application__form-container');
        const submitButtons = [...formContainer.querySelectorAll('button[type="submit"]')];
        if (submitButtons.length) {
            submitButtons.forEach(x => x.addEventListener("click", async e => {
                e.preventDefault();
                await that.handleFormSubmit(e);
            }))
        }
        const links = [...formContainer.querySelectorAll('.membership-application__prev-link')];
        if (links.length) {
            links.forEach(x => x.addEventListener('click', async e => {
                e.stopPropagation();
                e.preventDefault();
                await that.handleLink(e)
            }))
        }

        const expandElements = [...document.querySelectorAll('.membership-application__details')];
        if (expandElements.length) {
            expandElements.forEach(x => x.querySelector('.membership-application__details-toggler').addEventListener('click', this.handleToggleDetails))
        }
        
        this.initializeExpandableInfoElementsClickEvents();
    }
    
    initializeExpandableInfoElementsClickEvents() {
        const expandInfoElements = [...document.querySelectorAll('.membership-application__information-toggler')];
        if (expandInfoElements.length) {
            expandInfoElements.forEach(element => {
                element.addEventListener('click', this.handleToggleInfoDetails);
            });
        }
    }

    toggleInvoiceKind(e, currentBtn, otherBtn, radio) {
        e.stopPropagation();
        e.preventDefault();

        document.querySelectorAll('[invalid]').forEach(x => x.removeAttribute('invalid'))
        document.querySelectorAll('span[data-error-msg]').forEach(elem => elem.dataset.errorMsg = '')
        const pdfBtn = document.querySelector('.membership-application__step-four-button--pdf');
        const paperBtn = document.querySelector('.membership-application__step-four-button--paper');
        const invoiceEmailField = document.getElementById('Form_InvoiceEmail');
        const referenceField = document.getElementById('Form_Reference');
        const referenceLabel = document.querySelector('[for="Form_Reference"]')
        const referenceFieldPaper = document.getElementById('membership-application__input-container-reference');
        const addressField = document.getElementById('Form_Address');
        const invoiceEmailContainer = invoiceEmailField.parentElement.parentElement;
        const referenceContainer = referenceField.parentElement.parentElement;
        const addressContainer = addressField.parentElement.parentElement;

        currentBtn.style.color = '#006589'
        currentBtn.style.backgroundColor = '#E5F0F3'
        currentBtn.style.borderColor = '#006589'
        otherBtn.style.color = '#CBCDCD'
        otherBtn.style.backgroundColor = '#FFFFFF'
        otherBtn.style.borderColor = '#CBCDCD'

        currentBtn.disabled = true
        otherBtn.disabled = false
        if (radio.value === 'Pdf') {
            paperBtn.style.borderLeft = '1px solid #006589'
            pdfBtn.style.borderRight = 'none'
            addressContainer.style.display = "none";
            invoiceEmailContainer.style.display = "grid";
            referenceFieldPaper.style.display = "none";

        } else {
            referenceContainer.style.display = "grid";
            addressContainer.style.display = "grid";
            invoiceEmailContainer.style.display = "none";
            referenceFieldPaper.style.display = "grid";
        }
        if (radio.checked) {
            return
        }
        radio.checked = true
    }

    addEventListener() {
        this.addInputEventListeners();
    }

    handleToggleDetails(e) {
        const toggler = e.target;
        if (toggler.parentElement.classList.contains('membership-application__details--closed')) {
            toggler.parentElement.classList.remove('membership-application__details--closed');
            toggler.innerText = "Stäng"
        } else {
            toggler.parentElement.classList.add('membership-application__details--closed');
            toggler.innerText = "Läs mer"
        }
    }
    
    handleToggleInfoDetails(e) {
        const toggler = e.target;
        if (toggler.classList.contains('fa-circle-info')) {
            toggler.classList.remove('fa-circle-info');
            toggler.classList.add('fa-circle-xmark');
        } else {
            toggler.classList.remove('fa-circle-xmark');
            toggler.classList.add('fa-circle-info');
        }
        const infoDetails = toggler.nextElementSibling;
        infoDetails.classList.toggle('show');
    }
    
    async handleFormSubmit(e, skipFormUpdate) {
        if (this.formController) {
            this.formController.abort();
        }
        this.formController = new AbortController();
        const { signal } = this.formController;
        const formElement = document.querySelector('.membership-application__form')
        const errorMsgContainer = formElement.querySelector('.membership-application__error-message')
        errorMsgContainer.classList.remove('membership-application__error-message--visible')
        errorMsgContainer.innerHTML = "";
        formElement.classList.add('membership-application__form--loading');

        let button = e.target;
        if (button.tagName.toLowerCase() !== "button") {
            while (!button.matches('button[type=submit]')) {
                button = button.parentElement;

                if (button.parentElement.matches('.membership-application__form-container')) {
                    return;
                }
            }
        }
        document.querySelectorAll('[invalid]').forEach(x => x.removeAttribute('invalid'))
        document.querySelectorAll('span[data-error-msg]').forEach(elem => elem.dataset.errorMsg = '')
        const fetchTarget = formElement.action;
        const formData = new FormData(formElement);
        const data = {}
        for (const key of formData.keys()) {
            let val = formData.get(key);
            if (val === "on") {
                val = true;
            } else if (val === "off") {
                val = true;
            }
            data[key] = val;
        }

        data['Form.SkipValidation'] = !!skipFormUpdate;
        const buttonNameAttribute = button.attributes.getNamedItem('name')
        const buttonValueAttribute = button.attributes.getNamedItem('value')

        if (buttonNameAttribute && buttonValueAttribute) {
            const key = buttonNameAttribute.nodeValue.slice(0, 1).toUpperCase() + buttonNameAttribute.nodeValue.slice(1)
            const value = buttonValueAttribute.nodeValue.slice(0, 1).toUpperCase() + buttonValueAttribute.nodeValue.slice(1)
            data[key] = value;
        }

        const antiForgeryToken = document.querySelector('input[name=__RequestVerificationToken]').value;
        let response;
        try {
            response = await fetch(fetchTarget, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    '__RequestVerificationToken': antiForgeryToken
                },
                body: JSON.stringify(data),
                signal
            });
        } catch (e) {
            formElement.classList.remove('membership-application__form--loading');
            return;
        }

        if (!response.ok) {
            formElement.classList.remove('membership-application__form--loading');
            this.setError("Något gick fel, försök igen lite senare.", formElement)
            return;
        }
        if (data.hasOwnProperty("Form.UseElectronicId")) {
            const useElectronicId = data['Form.UseElectronicId'].toLowerCase() === 'true'
            if (!useElectronicId) {
                this.newMemberPrint()
                MembershipApplication.newMemberStepCompleted(6, this.selectedBranch, 'print')
                MembershipApplication.newMemberStepCompleted(7, this.selectedBranch, 'print')
            }
        }

        if (response.redirected) {
            window.location = response.url;
            return;
        }

        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") === -1) {
            //Content type is not JSON
            const pdf = await response.arrayBuffer();
            const link = document.createElement('a');
            const blob = new Blob([pdf], { type: "application/pdf" })
            link.href = URL.createObjectURL(blob)
            link.download = "Ansökan om medlemskap.pdf"
            document.body.append(link)
            link.click()
            setTimeout(() => location.reload(), 100)
            return;
        }
        const result = await response.json()

        const { errors, html, footer, errorMessage, progressHtml, redirectUrl, selectedBranch, expandableContactButtonHtml } = result;

        if (selectedBranch) this.selectedBranch = selectedBranch;

        if (redirectUrl) {
            const useElectronicId = !!data['Form.UseElectronicId'] && data['Form.UseElectronicId'].toLowerCase() === 'true'
            const signupType = useElectronicId ? 'bankID' : null;
            this.tryPushCurrentStep(signupType)
            window.location = redirectUrl;
            return;
        }

        if (errors && Object.keys(errors).length) {
            formElement.classList.remove('membership-application__form--loading');
            this.handleErrors(errors, errorMessage);
            return;
        }

        if (skipFormUpdate) {
            return true;
        }

        this.tryPushCurrentStep()

        const progressContainer = document.querySelector('.membership-application__progress-container')
        progressContainer.innerHTML = progressHtml;
        const formContainer = formElement.parentElement;
        const pageWrap = formContainer.closest('.page-wrap');
        formContainer.innerHTML = html;
        if (footer) {
            formContainer.insertAdjacentHTML('beforeend', footer);
        }
        if (expandableContactButtonHtml && !pageWrap.querySelector('.expandable-contact-button')) {
            pageWrap.querySelector('.membership-application__progress-container').insertAdjacentHTML('beforebegin', expandableContactButtonHtml);
            this.expandableContactButton.init();
        }

        new Tooltip();
        this.scrollIntoViewIfNeeded()
    }

    newMemberPrint() {
        dataLayer.push({
            'event': 'newMemberApplicationPrint',
            'selectedBranch': this.selectedBranch
        });
    }

    static newMemberStepCompleted(step, branch, signupType) {
        let data = {
            'event': 'newMemberCheckoutSteps',
            'checkoutSteps': `Step ${step}`,
            'selectedBranch': branch,
        }

        if (signupType) {
            data.signupType = signupType;
        }
        dataLayer.push(data);
    }

    static newMemberApplication(selectedBranch) {
        dataLayer.push({
            'event': 'newMemberApplication',
            'selectedBranch': selectedBranch
        })
    }

    handleErrors(errors, errorMessage) {
        const formElement = document.querySelector('.membership-application__form');
        this.setError(errorMessage, formElement)

        for (const [key, value] of Object.entries(errors)) {
            const inputElements = [...formElement.querySelectorAll(`[name="Form.${key.charAt(0).toUpperCase() + key.slice(1)}"]`)];
            for (const elem of inputElements) {
                if (elem.matches('input[type=radio]')) {
                    const radioList = document.querySelector('.membership-application__radio-buttons');
                    if (!radioList.attributes.getNamedItem('invalid'))
                        radioList.setAttribute('invalid', 'true')
                }
                const closestSpan = elem.parentElement.querySelector('span');

                if (!closestSpan) continue;

                elem.setAttribute('invalid', 'true');
                closestSpan.dataset.errorMsg = value;
            }

        }
    }

    async handleLink(e, submitForm) {
        if (this.controller) {
            this.controller.abort();
        }
        this.controller = new AbortController();
        const { signal } = this.controller;
        const formElement = document.querySelector('.membership-application__form')

        let link = e.target;
        while (!link.matches('a')) {
            link = link.parentElement;
            if (link.matches('body')) {
                return;
            }
        }
        const fetchTarget = link.href;
        formElement.classList.add('membership-application__form--loading');

        const antiForgeryToken = document.querySelector('input[name=__RequestVerificationToken]').value;

        let response;

        if (submitForm) {
            let button = formElement.querySelector('button[type=submit]');
            let success = await this.handleFormSubmit({ target: button }, true)
            if (!success)
                return;
        }

        try {
            response = await fetch(fetchTarget, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    '__RequestVerificationToken': antiForgeryToken
                },
                signal
            });
        } catch (e) {
            formElement.classList.remove('membership-application__form--loading');
            return;
        }

        if (!response.ok) {
            this.setError("Något gick fel, försök igen lite senare.", formElement)
            return;
        }
        formElement.classList.remove('membership-application__form--loading');

        const result = await response.json()
        const { html, progressHtml, footer, redirectUrl, selectedBranch } = result;

        if (selectedBranch) this.selectedBranch = selectedBranch;

        if (redirectUrl) {
            window.location = redirectUrl;
            return;
        }

        const formContainer = formElement.parentElement;
        const progressContainer = document.querySelector('.membership-application__progress-container')
        progressContainer.innerHTML = progressHtml;
        formContainer.innerHTML = html;
        if (footer) {
            formContainer.insertAdjacentHTML('beforeend', footer);
        }
        
        new Tooltip();
        this.scrollIntoViewIfNeeded()
    }

    scrollIntoViewIfNeeded() {
        const elem = document.querySelector('.membership-application__heading');
        if (elem.getBoundingClientRect().top < 0) {
            elem.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }

    setError(errorMessage, formElement) {
        const errorMsgContainer = formElement.querySelector('.membership-application__error-message')
        errorMsgContainer.classList.add('membership-application__error-message--visible')
        errorMsgContainer.innerHTML = errorMessage;
    }

    addProgressEventListeners() {
        const that = this;
        const progressContainer = document.querySelector('.membership-application__progress-container');
        progressContainer.querySelectorAll('a').forEach(x => x.addEventListener('click', async e => {
            e.stopPropagation();
            e.preventDefault();
            await that.handleLink(e, true)
        }))
    }

    tryPushCurrentStep(signupType = null) {
        const progressList = document.querySelector('.membership-application__progress-list');
        const currentStep = progressList.dataset.completedStep;
        if (!currentStep) return;
        MembershipApplication.newMemberStepCompleted(currentStep, this.selectedBranch, signupType)
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const selectedBranchDataNode = document.querySelector('[data-membership-application-page]')
    const isThankYouPage = !!selectedBranchDataNode;

    if (isThankYouPage) {
        const selectedBranch = selectedBranchDataNode.dataset.membershipApplicationPage;
        MembershipApplication.newMemberStepCompleted(7, selectedBranch, 'bankID')
        MembershipApplication.newMemberApplication(selectedBranch)
    }

    const isMembershipApplicationPage = !!document.querySelector('.membership-application')
    if (!isMembershipApplicationPage)
        return;
    new MembershipApplication()
})

